const getInitialValues = () => {
  return {
    customerData: {
      deliveryAddressActive: false,
      deliveryAddress: {
        deviatingFirstName: '',
        deviatingLastName: '',
        countryCode: 'DE',
        street: '',
        houseNumber: '',
        zipCode: '',
        city: '',
      },
    },
  }
}

export default getInitialValues